import { render, staticRenderFns } from "./EditProfession.vue?vue&type=template&id=50159783&scoped=true"
import script from "./EditProfession.vue?vue&type=script&lang=js"
export * from "./EditProfession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50159783",
  null
  
)

export default component.exports